/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Alert, Box, Button, Divider, FormControlLabel, Grid, Stack, Switch, TextField, Typography } from '@mui/material';
import { useTheme, alpha } from '@mui/material/styles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import { toast } from 'react-toastify';
import { patchApi } from 'views/services/api';

export default function StepSegoIA({ hotel, hotelId, onNext, onBack }) {
  const theme = useTheme();
  const [aiEnabled, setAiEnabled] = useState(hotel?.aiEnabled || false);
  const [managerPhone, setManagerPhone] = useState(hotel?.managerPhone || '');
  const [managerPhone2, setManagerPhone2] = useState(hotel?.managerPhone2 || '');
  const [saving, setSaving] = useState(false);

  const handleNext = async () => {
    if (aiEnabled && !managerPhone.trim()) {
      toast.error('Ingresa el número de WhatsApp del gerente para activar Sego IA');
      return;
    }

    setSaving(true);
    try {
      const res = await patchApi(`api/hotel/updateAIManagerConfig/${hotelId}`, {
        managerPhone: managerPhone.trim(),
        managerPhone2: managerPhone2.trim(),
        aiEnabled
      });
      if (res?.status === 200) {
        if (aiEnabled) toast.success('Sego IA activado');
        onNext();
      } else {
        toast.error('No se pudo guardar la configuración de Sego IA');
      }
    } catch (e) {
      console.error(e);
      toast.error('Error guardando la configuración de Sego IA');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Stack spacing={3}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: 3,
            backgroundColor: alpha(theme.palette.secondary.main, 0.1),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <SmartToyIcon sx={{ fontSize: 28, color: theme.palette.secondary.main }} />
        </Box>
        <Box>
          <Typography variant="h4">Asistente Sego IA (opcional)</Typography>
          <Typography variant="body2" color="text.secondary">
            Tu asistente inteligente por WhatsApp: consulta disponibilidad, reservas y métricas de tu hotel escribiéndole como a un
            empleado más.
          </Typography>
        </Box>
      </Stack>

      <FormControlLabel
        control={<Switch checked={aiEnabled} onChange={(e) => setAiEnabled(e.target.checked)} color="secondary" />}
        label="Activar asistente Sego IA"
      />

      {aiEnabled && (
        <Grid container spacing={2.5}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="WhatsApp del gerente (Ej: +584141234567)"
              value={managerPhone}
              onChange={(e) => setManagerPhone(e.target.value)}
              helperText="Número principal autorizado para hablar con Sego IA"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="WhatsApp secundario (opcional)"
              value={managerPhone2}
              onChange={(e) => setManagerPhone2(e.target.value)}
              helperText="Segundo número autorizado"
            />
          </Grid>
          <Grid item xs={12}>
            <Alert severity="info">
              Por seguridad, Sego IA solo responderá a los números configurados aquí. Los mensajes de tus clientes (pre-reservas,
              consultas) siguen funcionando normalmente.
            </Alert>
          </Grid>
        </Grid>
      )}

      <Divider />

      <Stack direction="row" justifyContent="space-between">
        <Button startIcon={<ArrowBackIcon />} onClick={onBack} sx={{ textTransform: 'none' }} disabled={saving}>
          Atrás
        </Button>
        <Stack direction="row" spacing={2}>
          <Button variant="outlined" onClick={onNext} disabled={saving} sx={{ textTransform: 'none' }}>
            Omitir por ahora
          </Button>
          <Button variant="contained" color="secondary" onClick={handleNext} disabled={saving} sx={{ px: 4, fontWeight: 600 }}>
            {saving ? 'Guardando...' : 'Guardar y continuar'}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}
